// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"f4ce7328","752":"f0a5d14e"}[chunkId] + ".chunk.js";
};